/* global CONFIGURATION, PartnerApp, Frontegg */

module.exports = {
  add: (app) => {
    const script = document.createElement("script");
    script.src = CONFIGURATION.apiUrl + "/partner-app.js?ts=" + Date.now();
    script.async = true;

    document.body.appendChild(script);

    script.onload = () => {
      app.ports.partnerAppsMount.subscribe(({ id, appId, type_ }) => {
        const apiUrl = CONFIGURATION.apiUrl;

        const attemptMount = (retryCount = 0) => {
          const maxRetries = 50;
          const retryDelay = 100;

          const authState =
            Frontegg.AppHolder._apps.default.store.getState().auth;
          const token = authState.user?.accessToken;

          if (token) {
            PartnerApp.mount(id, { appId, type: type_, token, apiUrl });
          } else if (retryCount < maxRetries) {
            setTimeout(() => attemptMount(retryCount + 1), retryDelay);
          } else {
            console.error("Could not get access token from frontegg");
          }
        };

        attemptMount();
      });
    };
  },
};
